import { Icon } from "@material-ui/core";
import React from "react";
import styled, { css } from "styled-components";

import { LibraryView } from "common/constants";
import { SideBarItem } from "js/editor/PresentationLibrary/PresentationLibrarySideBar";
import { themeColors } from "js/react/sharedStyles";

/** Views that share the library navigation sidebar shell. */
export type LibraryNavigationView =
    typeof LibraryView.LIBRARY |
    typeof LibraryView.TEMPLATES |
    typeof LibraryView.TEAM_RESOURCES |
    typeof LibraryView.DISCOVER_TEAM_PLAN;

export const libraryNavIconFilled = css`
    font-variation-settings: "FILL" 1;
`;

export const libraryNavIconOutlined = css`
    font-variation-settings: "FILL" 0;
`;

const BaseIcon = styled(Icon)`
    &&& {
        color: #DDD;
        font-size: 20px;
    }
`;

type StyledNavigationIconProps = {
    className?: string;
    children: React.ReactNode;
};

export function StyledNavigationIcon({ className, children }: StyledNavigationIconProps) {
    return (
        <BaseIcon
            className={["material-symbols-outlined", className].filter(Boolean).join(" ") || undefined}
        >
            {children}
        </BaseIcon>
    );
}

export const StyledNavigationSideBarItem = styled(SideBarItem)`
    &&& {
        color: #EEE;
        border-radius: 2px;
        
        & > .material-icons {
            font-size: 18px;
            ${libraryNavIconFilled}
        }

        &:hover {
            color: #EEE;
            background:#444444;

            & > .material-icons {
                color: ${themeColors.ui_blue};
            }
        }

        &.selected {
            background: #E9E9E9;
            color: #444444;
            

            & > .material-icons {
                color: ${themeColors.ui_blue};
                ${libraryNavIconOutlined}
            }
        }
    }
`;

export function navigationSelectedClass(selected: boolean) {
    return selected ? "selected" : "";
}
